import * as angular from "angular";
import {IController} from "angular";

export class BringozPackageItemCtrl implements IController {

  id: string;
  icon: string;
  name: string;
  nameOnly: boolean;
  packingDisplayStatus: string;
  isMissingPackage: boolean;

  public sitePackageItemsMap: {};
  public item: any;

  /* @ngInject */
  constructor(private splitService) {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
  }

  $onInit() {
    this.item = this.id ? this.sitePackageItemsMap[this.id] : undefined;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component( 'bringozPackageItem', {
    bindings: {
      id: '<?',
      icon: '<?',
      name: '<?',
      isMissingPackage: '<?',
      packingDisplayStatus: '<?',
      nameOnly: '<?'
    },
    template: require('./bringoz-package-item.html').default,
    controller: BringozPackageItemCtrl
  });
